import React from 'react';

const IntroLambrinSintetico = () => {
  return (
    <section className="bg-light">
      <div className="container mt-lg-3 mt-xl-0">
        <div className="row clearfix align-items-xl-center">
          <div className="col-lg-6 mb-2-9 mb-lg-0 position-relative wow fadeIn" data-wow-delay="400ms">
            <div className="position-relative">
              <div className="text-center text-sm-end text-md-center text-lg-end pe-xxl-1-9 overflow-hidden position-relative">
                <img 
                  src="/assets/img/productos/muro-lambrin-sintetico/muro-lambrin-sintetico-intro.jpg" 
                  alt="piso vinilico" 
                  className="rounded" 
                />
              </div>
              <img 
                src="/assets/img/productos/muro-lambrin-sintetico/muro-lambrin-sintetico-intro-small.jpg" 
                className="rounded position-absolute top-15 d-none d-sm-block" 
                alt="piso vinilico 2" 
              />
            </div>
          </div>
          <div className="col-lg-6 text-column">
            <div className="ps-lg-2-3">
              <div className="title-style2 mb-1-6 wow fadeInUp" data-wow-delay="200ms">
                <h2 className="h1">Lambrín Sintético: Soluciones Versátiles para Revestimientos de Muros</h2>
              </div>
              <p className="mb-2-2 wow fadeInUp" data-wow-delay="200ms">
              El lambrín sintético es la solución perfecta para transformar tus espacios interiores y exteriores con estilo, resistencia y sostenibilidad. 
              Diseñado para ofrecer la apariencia de materiales tradicionales, pero con las ventajas de la tecnología moderna, 
              este producto se adapta a las necesidades de arquitectos y diseñadores que buscan combinar funcionalidad y estética en sus proyectos.
              </p>
              <div className="bg-dark ps-2-3 pe-10 py-1-9 position-relative border-radius-10 wow fadeInUp" data-wow-delay="200ms">
                <p className="mb-0 lead font-weight-500 position-relative z-index-9 text-white">
                Fácil instalación y bajo mantenimiento: Ahorra tiempo en obra y se limpia fácilmente, manteniendo su estética impecable.
                </p>
                <img 
                  src="/assets/img/content/quote-right.png" 
                  className="position-absolute top-0 right" 
                  alt="icono" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-inline-block bg-secondary p-3 ani-zoomin rounded-circle position-absolute top-8 right-5 z-index-1 opacity1"></div>
    </section>
  );
};

export default IntroLambrinSintetico;